import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import { useCollectionStateContext } from 'Context/CollectionStateContext';
import { Content } from './Content';


const UserAuthSetupContainer = () => {
  const { isInitializing, loadingError, collection } = useCollectionStateContext();

  return (
    <DataContainer
      component={Content}
      loading={isInitializing}
      loadingError={loadingError}
      componentProps={{
        collection,
      }}
    />
  );
};

UserAuthSetupContainer.propTypes = {
};

export default UserAuthSetupContainer;
